<div class="content content-fixed h-screen -mt-10">
  <div class="w-full h-full flex pt-8">
    <!-- Sidebar -->
    <div class="w-1/12 h-full flex flex-col items-start pt-4 p-2 bg-white overflow-hidden rounded-e-2xl mt-5">
      <button (click)="togglePopup()" class="mb-4 p-2 flex justify-center bg-blue-500 text-white rounded-lg w-full">
        Compose
      </button>
      <p (click)="filterEmails('sent')" class="mt-2 cursor-pointer hover:text-blue-500">Sent</p>
      <p (click)="filterEmails('inbox')" class="mt-2 cursor-pointer hover:text-blue-500">Inbox</p>
      <p (click)="filterEmails('pending')" class="mt-2 cursor-pointer hover:text-blue-500">Draft</p>
      <p (click)="filterEmails('trash')" class="mt-2 cursor-pointer hover:text-blue-500">Trash</p>
    </div>

    <!-- Popup -->
    <div *ngIf="isPopupVisible" class="fixed inset-x-0 bottom-0  flex items-center justify-end bg-opacity-50 z-50">

      <div class="bg-white p-0 rounded-lg shadow-lg relative"
        style="width: 700px; height: 600px; margin-bottom: 4px; left: -130px;">

        <div [ngClass]="{'hidden': isMinimized}" class=" bg-slate-100 pl-4 flex items-center"
          style="height: 50px; margin-bottom: 10%;">
          <h2 class="text-xl text-black mb-0">New Message</h2>


          <div class="ml-auto flex space-x-2">

            <button (click)="togglePopup()">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="mb-4 border-b border-gray-300 w-full">

          <div class="flex items-center mb-2">
            <h3 class="text-lg font-semibold p-2 mb-0 mr-2">To</h3>
            <input type="text" class="flex-grow px-3 py-2 " placeholder="" />

            <div class="flex ml-auto space-x-4">
              <a href="javascript:void(0);" (click)="toggleCc()" class="link-style">
                Cc
              </a>
              <a href="javascript:void(0);" (click)="toggleBcc()" class="link-style">
                Bcc
              </a>
            </div>
            
          </div>

          <div *ngIf="isCcVisible" class="flex items-center mb-2">
            <h3 class="text-lg font-semibold p-2 mb-0 mr-2">Cc</h3>
            <input type="text" class="flex-grow px-3 py-2 " placeholder="" />
          </div>

          <div *ngIf="isBccVisible" class="flex items-center">
            <h3 class="text-lg font-semibold p-2 mb-0 mr-2">Bcc</h3>
            <input type="text" class="flex-grow px-3 py-2 " placeholder="" />
          </div>
        </div>

        <div class="mb-4 flex items-center border-b border-gray-300 ">
          <h3 class="text-lg font-semibold p-2 mb-0 mr-2">Subject</h3>
          <input type="text" class="flex-grow px-3 py-2 focus:outline-none focus:ring-0 focus:border-blue-500"
            placeholder="">
        </div>

        <div class="send-button flex items-center space-x-2">

          <button (click)="sendEmail()" [disabled]="isSending">
            <span *ngIf="isSending">Sending...</span>
            <span *ngIf="!isSending">Send</span>
            <button (click)="toggleDropdown()" class=" pl-2 border-gray-300 ">
              ▼
            </button>
          </button>
        </div>


        <div class="attachment-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-paperclip"
            viewBox="0 0 16 16" (click)="triggerFileInput()">
            <path
              d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
          </svg>
          <input type="file" id="fileInput" #fileInput style="display: none;" (change)="onFileSelected($event)" />
        </div>
      </div>
    </div>


    <!-- Main Content -->
    <div class="flex-1 h-full p-4 overflow-hidden flex flex-col mt-5">
      <!-- Search Bar -->
      <div class="w-full flex items-center justify-center mb-4">
        <input type="text" placeholder="Search Email or ID"
          class="w-1/3 m-2 h-10 rounded-full pl-4 shadow-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
          [(ngModel)]="searchTerm" (input)="searchQueryEmails()" />
      </div>


      <!-- Main Mail View Content -->
      <div class="bg-white flex-1 w-full rounded-lg shadow-md px-4 overflow-auto">
        <div class="w-full mt-4 h-full">
          <!-- Scrollable Table Body Container -->
          <table class="w-full table-fixed border-collapse bg-white shadow-md rounded-lg">
            <thead class="sticky top-0 w-full">
              <tr class="bg-gray-700 text-white headers">
                <!-- Updated header colors -->
                <th class="w-12 p-4">
                  <input type="checkbox" class="form-checkbox rounded" (change)="toggleSelectAll($event)" />
                </th>
                <th class="w-24 p-4 text-left">ID</th>
                <th class="w-60 p-4 text-left">Email</th>
                <th class="w-full p-4 text-left">Body Text (Preview)</th>
                <th class="w-40 p-4 text-center">Date / Time</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let email of filteredEmails?.contents" (click)="emailClick(email)"
                class="table-body-row border-b">
                <td class="px-4 py-2">
                  <input type="checkbox" class="form-checkbox rounded" [(ngModel)]="email.selected" />
                </td>
                <td class="px-4 py-2 text-gray-800">{{ email.ID }}</td>
                <td class="px-4 py-2 text-gray-800 truncate">{{ email['Receiver Emails'] }}</td>
                <td class="px-4 py-2 text-gray-800 truncate">{{ email['Body Text'] }}</td>
                <td class="px-4 py-2 flex justify-end items-center text-center">{{ email['Send date & time'] }}</td>
              </tr>
              <tr *ngIf="filteredEmails?.contents?.length === 0">
                <td colspan="6" class="text-center py-4 text-gray-500">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Popup Screen -->
<div *ngIf="isPopupOpen" class="fixed inset-0 flex items-start justify-center bg-gray-900 bg-opacity-50"
  style="z-index: 1000;">
  <div class="w-5/6 h-5/6 bg-white rounded-lg mt-5"> <!-- Changed h-4/6 to h-5/6 -->
    <h1 class="w-full flex justify-end text-xl pr-2 cursor-pointer" (click)="close()">X</h1>

    <div class="flex w-full h-auto justify-between p-1 items-start">
      <div class="flex items-start gap-1">
        <p class="font-bold text-xl">From: {{ selectedMail.sender_email }}</p>
      </div>

      <div class="ml-auto text-right">
        <p class="font-bold text-xl">To: {{ selectedMail.receiver_emails }}</p>
        <p>
          {{ isToday(selectedMail.modified_on) ? (selectedMail.modified_on | date: 'h:mm a') :
          (isYesterday(selectedMail.modified_on) ? 'Yesterday' : (selectedMail.modified_on | date: 'd MMM yyyy')) }}
        </p>
      </div>
    </div>

    <!-- Increased the content height -->
    <div class="w-full h-full overflow-auto bg-white p-4">
      <div [innerHTML]="sanitizedEmailBody"></div>
    </div>
  </div>
</div>
